import apiClient from './apiClient';

export const chatApi = {
  /**
   * Sendet eine Chat-Nachricht an den KI-Assistenten
   * @param {string} message - Die Nachricht
   * @param {string|null} konversationId - Optional: ID einer bestehenden Konversation
   * @param {string[]|null} imageIds - Optional: IDs von hochgeladenen Bildern für Vision-Analyse
   * @returns {Promise<{konversationId: string, message: string, toolResults?: array}>}
   */
  sendMessage: async (message, konversationId = null, imageIds = null) => {
    const response = await apiClient.post('/chat', {
      message,
      konversationId,
      imageIds
    });
    return response.data;
  },

  /**
   * Lädt ein Bild für die Chat-Vision-Analyse hoch
   * @param {File} file - Die Bilddatei
   * @returns {Promise<{id: string, dateiname: string, originalname: string, mimeType: string, groesse: number, expiresAt: string}>}
   */
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    const response = await apiClient.post('/chat/upload-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  /**
   * Löscht ein hochgeladenes Chat-Bild
   * @param {string} id - Bild-ID
   * @returns {Promise<{message: string}>}
   */
  deleteImage: async (id) => {
    const response = await apiClient.delete(`/chat/images/${id}`);
    return response.data;
  },

  /**
   * Startet eine neue leere Konversation
   * @returns {Promise<{id: string, titel: string}>}
   */
  neueKonversation: async () => {
    const response = await apiClient.post('/chat/neue-konversation');
    return response.data;
  },

  /**
   * Lädt alle Konversationen des Users
   * @returns {Promise<Array<{id: string, titel: string, letzteNachricht: string, updatedAt: string}>>}
   */
  getKonversationen: async () => {
    const response = await apiClient.get('/chat/konversationen');
    return response.data;
  },

  /**
   * Lädt eine einzelne Konversation mit allen Nachrichten
   * @param {string} id - Konversations-ID
   * @returns {Promise<{id: string, titel: string, nachrichten: array}>}
   */
  getKonversation: async (id) => {
    const response = await apiClient.get(`/chat/konversationen/${id}`);
    return response.data;
  },

  /**
   * Löscht eine Konversation
   * @param {string} id - Konversations-ID
   * @returns {Promise<{message: string}>}
   */
  deleteKonversation: async (id) => {
    const response = await apiClient.delete(`/chat/konversationen/${id}`);
    return response.data;
  },

  /**
   * Durchsucht Konversationen nach Keyword (Titel + Nachrichteninhalte)
   * @param {string} query - Suchbegriff (min. 2 Zeichen)
   * @returns {Promise<Array<{id: string, titel: string, letzteNachricht: string, updatedAt: string, matchType: string}>>}
   */
  sucheKonversationen: async (query) => {
    const response = await apiClient.get(`/chat/konversationen/suche?q=${encodeURIComponent(query)}`);
    return response.data;
  },

  /**
   * Löscht alle Konversationen des Users
   * @returns {Promise<{message: string, count: number}>}
   */
  deleteAlleKonversationen: async () => {
    const response = await apiClient.delete('/chat/konversationen');
    return response.data;
  }
};
